import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const misc = /*           */ asExport(o_util, "misc", {});
const getPagecluster = /*           */ asExport(
  misc,
  "getPagecluster",
  noop
);
const guid = /*           */ asExport(misc, "guid", noop);
const isPreview = /*           */ asExport(misc, "isPreview", noop);
const isPrivacyPage = /*           */ asExport(
  misc,
  "isPrivacyPage",
  noop
);
const isValidMouseButton = /*           */ asExport(
  misc,
  "isValidMouseButton",
  noop
);
const nanoid = /*           */ asExport(misc, "nanoid", noop);
const urlToLinkObject = /*           */ asExport(
  misc,
  "urlToLinkObject",
  noop
);
const setVendorStyle = /*           */ asExport(
  misc,
  "setVendorStyle",
  noop
);
const isResponsive = /*           */ asExport(
  misc,
  "isResponsive",
  noop
);
export {
  getPagecluster,
  guid,
  isPreview,
  isPrivacyPage,
  isResponsive,
  isValidMouseButton,
  misc,
  nanoid,
  setVendorStyle,
  urlToLinkObject
};
/*                                    */
